<template>
  <div class="feedbackReceivedView  height-100">
    <van-overlay :show="overlayShow" @click="show = false" z-index="9999"/>
    <div class="bg-FF flex row-center fixed width-100 abso z-999 pos-t-0  font-28 cor-66 p-24">
        <!-- <van-icon name="arrow-left"  @click="clickDate('prev') "   :class="dateArray.indexOf(selectedDate) >= dateArray.length - 1 ? 'disabled-icon' : ''" />
        <div class="p-l-10 cor-66 p-r-10">{{ selectedDate }}</div>
        <van-icon name="arrow"  @click="clickDate('next')"    :class="dateArray.indexOf(selectedDate) <= 0 ? 'disabled-icon' : ''"/> -->
        <van-icon name="arrow-left"  @click="clickDate('prev')"    :class="dateArray.indexOf(selectedDate) <= 0 ? 'disabled-icon' : ''" />
        <div class="p-l-10 cor-66 p-r-10">{{ selectedDate }}</div>
         <van-icon name="arrow"   @click="clickDate('next')"     :class="dateArray.indexOf(selectedDate) >= dateArray.length - 1 ? 'disabled-icon' : ''"/>
    </div>
    <div v-if="projectList.length==0" class="width-100 height-100 noDataBox flex row-center col-center">
        <img src="@/assets/icon/feedbackStatistics/noData.png" alt="没有数据" class="width-50 m-l-40">
        <p class="cor-66 m-t-24 font-28">该员工当天没有工作反馈</p>
    </div>
    <div v-else  class="p-b-98  p-l-24 p-r-24 m-b-80 p-t-100">
        <div  class="flex row-between p-t-16 p-b-16" v-if="feedbackHour"> 
            <div :class="getFeedbackHourStyle(feedbackHour)" class="b-tr-r-40 b-br-r-40 font-32 p-t-10 p-b-10 cor-33  p-r-24  p-l-24 ">{{ feedbackHourCn}}</div>
            <div class="cor-66 font-32">{{feedbackHour}}小时</div>
        </div>
        <!-- <van-pull-refresh v-model="refreshing" @refresh="onRefresh" > -->
        <van-list
            v-model="loading"
            :immediate-check="false"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
        >
    <div v-for="(projectItem,index) in projectList" class="feedbackReceivedViewList" :key="index">
        <div class=" feedbackReceivedViewTitle  m-b-24  m-t-24">
            <img src="@/assets/icon/feedbackStatistics/projectIcon.png" alt="项目" class="w-40 h-38 m-r-16">
            <span class="cor-33 font-28">{{ projectItem.projectName }}</span>
        </div>
        <div v-for="(tasksItem,index) in projectItem.tasks" :key="index" class="bg-FF p-t-32 p-b-32 p-l-24 p-r-24 font-28 rela  " :class="index==projectItem.tasks.length-1?'':'m-b-24'">
            <div class="m-b-24 flex col-top"><div class="cor-66 ">任务：</div> <div class="cor-33 flex-1"> {{ tasksItem.taskName}}</div></div>
            <div class="m-b-24 flex col-top" ><div class="cor-66">工作内容：</div><div  class="cor-33 flex-1"  >{{ tasksItem.message}}</div></div>
            <div class="m-b-24 flex col-top"><div class="cor-66">任务投入工时：</div><div  class="cor-33 flex-1">{{ tasksItem.hour}}小时</div></div>
            <div class="m-b-24 flex col-top"><div class="cor-66">附件：</div><div  class="cor-33 flex-1 ">
                <fileComponent :tasksItem="tasksItem" ref="fileComponent"/>
                <!-- <div class="m-r-12 " v-for="(item, index) in tasksItem.fileList" :key="index">
                    <van-image v-if="item.fileURL || item.fileUrl" width="100" height="100" fit="contain" :src="item.fileURL || item.fileUrl" @click="show=true" />
                </div>
                <van-image-preview v-model="show" :images="tasksItem.fileImgList.filter(url => url)"  @change="onChange">
                </van-image-preview> -->
            </div>
        </div>
            <div class="text-right">
                <van-button type="primary" round @click="commentClick(projectItem,tasksItem)"   class="w-300 h-50 tasksBtn rela font-28">评论 <div v-show="Number(tasksItem.commentNum)>0" class="abso pos-neg-t-28 pos-r-8 font-45  commentBox">●</div></van-button>
            </div>
            <div class="abso pos-t-0 pos-r-0">
                <div class="w-130 h-30 l-h-30  progressBox font-22 text-right p-r-24"  :class="tasksItem.progress==100?'progressBoxBai':''">{{ tasksItem.progress }}%</div>
            </div>
            
        </div>
    </div>
        </van-list>
        <!-- </van-pull-refresh> -->
    </div>
    <div class="p-l-24 p-r-24 p-b-24 fixed width-100 abso pos-b-0 backBox">
        <van-button   @click="backList()"   class="width-100 h-60   cor-33 font-28">返回</van-button>
    </div>
    <commentForm ref="commentForm"/>
   
  </div>
</template>

<script>
import mixin from '@/mixin/flow'
import {methodGetApi} from "@/api/publicApi";
import commentForm from '@/views/feedbackStatistics/components/commentForm.vue'
import fileComponent from '@/views/feedbackStatistics/components/fileComponent.vue'
import cache from "@/plugins/cache";
import { number } from 'echarts';
export default {
  name: 'feedbackReceivedView',
  mixins: [mixin],
  components: {commentForm,fileComponent},
provide() {
    return {
      feedbackReceivedViewProvide: this
    }
  },
  data() {
    return {
        show:false,
        overlayShow:false,
        dateArray:[],//期日数组
        selectedDate: '',//当前的时间
        projectList:[],//项目列表节点的任务数据
        feedbackHour:0,//反馈工时
        formQuery:{
            pageNum: 1,
            pageSize: 10,
        },
        loading: false,
        finished: false,
        refreshing: false,
        totalRecords: 0, // 总记录数
        allProjects: [], // 存储所有项目数据，用于合并
    }
  },
  computed: {
  // 计算整体工时状态（根据所有任务的总工时）
  feedbackHourCn() {
    if (this.projectList.length>0) {
      let totalFeedbackHour = 0;
      let taskCount = 0;
      
      for (let project of this.projectList) {
        for (let task of project.tasks) {
          totalFeedbackHour += task.feedbackHour || 0;
          taskCount++;
        }
      }
      
      if (taskCount === 0) return '标准时长';
      
      const avgFeedbackHour = totalFeedbackHour / taskCount;
      
      if (avgFeedbackHour < 7) {
        return '工时未满';
      } else if (avgFeedbackHour > 8) {
        return '加班工时';
      } else {
        return '标准时长';
      }
    }
    return '标准时长';
  }
},
  created() {
  },
  mounted() {
    this.query=this.$route.query
    console.log(this.$route.query)
    this.getDateRangeArray()
 
  },
  methods: {
    // 根据反馈工时返回样式类
    getFeedbackHourStyle() {
        if (this.feedbackHour < 7) {
        return 'feedback-hour-low'; // 灰底黑字
        } else if (this.feedbackHour > 8) {
        return 'feedback-hour-high'; // 蓝底红字
        } else {
        return 'feedback-hour-normal'; // 黄底白字
        }
    },
    // 获取日期范围数组（升序）
    getDateRangeArray() {
        const startDate = new Date(this.$route.query.startTime);
        const endDate = new Date(this.$route.query.endTime);
        const dateArray = [];
        const currentDate = new Date(startDate);
        
        // 遍历从开始日期到结束日期的所有日期
        while (currentDate <= endDate) {
            dateArray.push(currentDate.toISOString().split('T')[0]); // 格式化为 YYYY-MM-DD
            currentDate.setDate(currentDate.getDate() + 1); // 增加一天
        }
        
        console.log(dateArray);
        
        // 按时间升序排列（从早到晚）
        this.dateArray = dateArray; // 移除 .reverse()，保持升序
        this.selectedDate = this.dateArray[0]; // 默认选择第一个日期（最早的日期）
        
        this.formQuery.nickName = this.query.nickNameItem;
        this.formQuery.userId = this.query.userIdItem;
        this.formQuery.deptId = this.query.deptId;
        this.overlayShow = true;
        this.getDetail(this.selectedDate);
    },
    //评论点击
    commentClick(projectItem,tasksItem){
        console.log(projectItem,tasksItem)
        this.$refs['commentForm'].commentShow=true
        this.$nextTick(() => {
            this.$refs['commentForm'].getTaskComment(tasksItem.taskId)
        })
    },
    backList(){
        let  query={activeIndex: 0}
        Object.assign(query,this.query)
        console.log(query)
        this.$router.push({path: '/feedbackStatistics', query: query})
    },
    //转换成以项目为节点的任务树
    arrTotreeData(list) {
    // 创建项目映射，以项目ID为键
    const projectsMap = {};

    // 只取第一条数据的feedbackHour
    let firstFeedbackHour = list.length > 0 ? list[0].feedbackHour || 0 : 0;

    list.forEach(item => {
        // 获取或创建项目
        let project = projectsMap[item.projectId];
        if (!project) {
        project = {
            projectId: item.projectId,
            projectName: item.projectName,
            tasks: []
        };
        projectsMap[item.projectId] = project;
        }

        // 统一附件字段名，将fileURL统一为fileUrl
        const processedFileList = item.fileList ? item.fileList.map(file => ({
        ...file,
        fileUrl: file.fileURL || file.fileUrl || file.filePath
        })) : [];

        // 添加任务到项目中（保持原始顺序）
        project.tasks.push({
        ...item,
        id: item.taskId,
        label: item.taskName,
        fileList: processedFileList, // 确保使用统一的字段名
        fileImgList: processedFileList.map(file => file.fileUrl) // 创建fileImgList数组
        });
    });

    // 转换为项目数组，保持原始顺序
    const projects = Object.values(projectsMap);

    // 返回项目列表和第一条的feedbackHour
    return {
        projects: projects,      // 以项目为父级，任务为子级的数组
        feedbackHour: firstFeedbackHour // 第一条数据的反馈工时
    };
    },
    //跳转详情
    async getDetail( selectedDate) {
        let url = '/project/statistics/feedbackStatisticsDetailYD'
        this.formQuery.startTime = selectedDate
        this.formQuery.endTime = selectedDate
        this.refreshing = false;
        // 获取第一页数据
        await methodGetApi(url, this.formQuery).then(async res => {
            this.totalRecords=res.total||0
            this.allProjects.push(...res.rows)
            let { projects, feedbackHour } = this.arrTotreeData(this.allProjects)
            this.feedbackHour = feedbackHour
            this.projectList =projects
            if (this.allProjects.length >= this.totalRecords) {
                this.finished = true;
            }
        this.overlayShow=false
        // 加载状态结束
        this.loading = false;
        })
    },

    // 上拉加载
    async onLoad() {
        console.log('往下拉了')
        console.log('this.totalRecords',this.totalRecords)
        console.log('this.totalRecords',this.allProjects.length)
        if (this.totalRecords ==this.allProjects.length || this.totalRecords ==0) {
         this.finished = true;
        }
        this.formQuery.pageNum++
        this.getDetail( this.selectedDate)
    },
    // 下拉刷新
    async onRefresh() {
     // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
    //   this.formQuery.pageNum=1
      if(this.formQuery.pageNum==1){
        this.allProjects=[]
        this.totalRecords=0
      }
    this.getDetail( this.selectedDate)
    },

    // 直接调用获取指定日期数据的方法
    getSpecificDateData(selectedDate,groupedData) {
        const targetData = groupedData.find(item => item.date === selectedDate);
        console.log(targetData,'targetData');
        return targetData || null;
    },
    // 切换日期
    clickDate(action) {
        if (action === 'prev') {
            // 向前切换日期（选择更早的日期）
            const currentIndex = this.dateArray.indexOf(this.selectedDate);
            if (currentIndex > 0) { // 在升序数组中，向前是索引减小
                const prevDate = this.dateArray[currentIndex - 1];
                this.selectedDate = prevDate;
                this.dataInit();
            } else {
                // 已经是最前日期，禁用点击
                this.$toast('已到达最早日期');
            }
        } else if (action === 'next') {
            // 向后切换日期（选择更晚的日期）
            const currentIndex = this.dateArray.indexOf(this.selectedDate);
            if (currentIndex < this.dateArray.length - 1) { // 在升序数组中，向后是索引增加
                const nextDate = this.dateArray[currentIndex + 1];
                this.selectedDate = nextDate;
                this.dataInit();
            } else {
                // 已经是最后日期，禁用点击
                this.$toast('已到达最新日期');
            }
        }
    },
    //评论组件调取函数
    dataInit(){
        this.projectList = []
        this.feedbackHour=0
        this.formQuery.pageNum= 1
        this.overlayShow=true
        this.loading= false,
         this.finished= false,
         this.refreshing=false,
         this.totalRecords= 0, // 总记录数
         this.allProjects=[], // 存储所有项目数据，用于合并
        this.getDetail(this.selectedDate);
    }
  }
}
</script>
<style lang="less" scoped>
.feedbackReceivedView{
    .feedbackReceivedViewTitle{
            display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: flex-start;
    }
    .progressBox{
        position: relative;
        background: url(~@/assets/icon/feedbackStatistics/progressBox.png) no-repeat 0 0;
        background-size: 100% 100%;
        color: #fff;
    }
    .progressBoxBai{
        background: url(~@/assets/icon/feedbackStatistics/progressBoxBai.png) no-repeat 0 0;
    }
    .backBox{
      background:@base-background-color ;
    }
    .tasksBtn{
        color: #fff;
    }
    .noDataBox{
        height: calc(100% - 120px);
        display: flex;
    flex-direction: column;
    align-items: center;
    }
    .commentBox{
      color: #EF0303; /* 灰色背景 */
    }
     // 工时样式
    .feedback-hour-low {
      background-color: #FCDA41; /* 灰色背景 */
  
    }
    
    .feedback-hour-normal {
      background-color: #CEE354; /* 黄色背景 */
   
    }
    
    .feedback-hour-high {
      background-color: #FFA8A8; /* 蓝色背景 */
    }
        
    // 禁用图标样式
    .disabled-icon {
      opacity: 0.5;
      pointer-events: none; /* 禁用点击事件 */
    }
}
</style>
